import { ListType } from '@convergence/types';
import { getError, valueFromTreeAndPath } from '../util';
import { AnalysisInputProps } from '../types';
import { Plus, X } from '@phosphor-icons/react';
import { AnalysisInputSwitch } from './analysis-input-switch';

export function AnalysisListInput(props: AnalysisInputProps<ListType>) {
  let value = valueFromTreeAndPath<any[]>(props.tree, props.propertyPath) ?? [];

  const error = getError(props.errors, props.propertyPath);

  return (
    <div className="py-2">
      <div className="flex gap-2 items-center">
        {props.name && <span className="font-bold ">{props.name}</span>}
      </div>
      <div className="flex flex-col gap-2 pl-4">
        {value.map((item, index) => (
          <div
            className="flex justify-between border-b border-black"
            key={index}
          >
            <AnalysisInputSwitch
              value={item}
              tree={props.tree}
              errors={props.errors}
              propertyPath={[...props.propertyPath, '_value', String(index)]}
              name=""
              onChange={props.onChange}
              key={index}
            />
            <button
              onClick={() => {
                const newValue = [...value];
                newValue.splice(index, 1);
                props.onChange(props.propertyPath, newValue);
              }}
            >
              <X />
            </button>
          </div>
        ))}
      </div>
      <button
        className="p-2"
        onClick={() => {
          props.onChange(props.propertyPath, [...value, props.value._schema]);
        }}
      >
        <Plus />
      </button>
      {error && <p className="text-red-500">{error.message}</p>}
    </div>
  );
}
